export const ConfiguredItemsNotAvailable = 'ConfiguredItemsNotAvailable';
export const ObsoleteItemsNotAvailable = 'ObsoleteItemsNotAvailable';
export const OrderUpdated = 'OrderUpdated';
export const UnableToAddToCart = 'UnableToAddToCart';